import type { Timestamp } from 'firebase/firestore';

export type NotificationType =
  | 'whatsapp_new_msg_assigned'
  | 'whatsapp_triage_grew'
  | 'whatsapp_msg_failed'
  | 'appointment_cancelled'
  | 'appointment_affected_by_block'
  | 'pregnancy_expired'
  | 'bot_handover'
  | 'intake_ready'
  | 'automation_failed'
  | 'support_ticket_opened'
  | 'support_ticket_reply'
  | 'support_ticket_status'
  | 'waitlist_slot_match'
  | 'franchise_usage'
  | 'gaius_billing';

export type NotificationPriority = 'low' | 'normal' | 'high';

export interface NotificationDoc {
  id: string;
  userId: string;
  type: NotificationType;
  title: string;
  body: string;
  link?: string;
  priority: NotificationPriority;
  metadata?: Record<string, unknown>;
  read: boolean;
  readAt?: Timestamp;
  createdAt?: Timestamp;
}

/** Grupos pros toggles de preferências e filtros. */
export const NOTIFICATION_GROUPS: Array<{
  group: string;
  types: Array<{ key: NotificationType; label: string; description: string }>;
}> = [
  {
    group: 'WhatsApp',
    types: [
      { key: 'whatsapp_new_msg_assigned', label: 'Nova mensagem em conversa minha', description: 'Quando respondem numa conversa sob sua responsabilidade.' },
      { key: 'whatsapp_triage_grew', label: 'Triagem cresceu (nova conversa)', description: 'Nova conversa sem dono entrou na triagem.' },
      { key: 'whatsapp_msg_failed', label: 'Mensagem outbound falhou', description: 'Uma mensagem que você enviou não foi entregue.' },
    ],
  },
  {
    group: 'Agenda',
    types: [
      { key: 'appointment_cancelled', label: 'Agendamento cancelado', description: 'Um agendamento foi cancelado.' },
      { key: 'appointment_affected_by_block', label: 'Bloqueio afeta agendamento', description: 'Um novo bloqueio sobrepõe agendamentos existentes.' },
      { key: 'pregnancy_expired', label: 'Gestação expirada', description: 'DUM/IG removida automaticamente (42+ semanas).' },
    ],
  },
  {
    group: 'Bot',
    types: [
      { key: 'bot_handover', label: 'Bot pediu atendimento humano', description: 'Cliente precisa de atendente (urgência).' },
      { key: 'intake_ready', label: 'Triagem do bot pronta', description: 'Bot finalizou a coleta e criou um agendamento pra confirmar.' },
    ],
  },
  {
    group: 'Sistema',
    types: [
      { key: 'automation_failed', label: 'Automação falhou', description: 'Uma automação WhatsApp falhou ao executar.' },
      { key: 'franchise_usage', label: 'Franquia do mês', description: 'Aviso quando a clínica chega a 80% e passa de 100% dos exames do plano.' },
      { key: 'gaius_billing', label: 'Cobrança do Ardix', description: 'Fatura disponível, vencimento, atraso e pagamento, sugestão de plano e decisão de upgrade.' },
    ],
  },
  {
    group: 'Suporte',
    types: [
      { key: 'support_ticket_opened', label: 'Novo chamado de suporte', description: 'Um chamado foi aberto (para quem gerencia suporte).' },
      { key: 'support_ticket_reply', label: 'Resposta em chamado', description: 'Nova resposta num chamado seu.' },
      { key: 'support_ticket_status', label: 'Status de chamado mudou', description: 'O status de um chamado seu foi alterado.' },
    ],
  },
  {
    group: 'Lista de Espera',
    types: [
      { key: 'waitlist_slot_match', label: 'Vaga disponível na lista de espera', description: 'Um cancelamento ou nova agenda liberou uma vaga para paciente(s) em espera.' },
    ],
  },
];

/** Ícone (lucide) por tipo — usado no popover/view. */
export const NOTIFICATION_ICON: Record<NotificationType, string> = {
  whatsapp_new_msg_assigned: 'MessageCircle',
  whatsapp_triage_grew: 'Inbox',
  whatsapp_msg_failed: 'AlertTriangle',
  appointment_cancelled: 'CalendarX',
  appointment_affected_by_block: 'CalendarClock',
  pregnancy_expired: 'Baby',
  bot_handover: 'Hand',
  intake_ready: 'ClipboardCheck',
  automation_failed: 'AlertOctagon',
  support_ticket_opened: 'LifeBuoy',
  support_ticket_reply: 'MessageSquare',
  support_ticket_status: 'CheckCircle2',
  waitlist_slot_match: 'Clock',
  franchise_usage: 'AlertTriangle',
  gaius_billing: 'Receipt',
};
